// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import axios from 'axios';

const axiosClient = axios.create({
  baseURL: '',
  withCredentials: true
});

// Recruiter APIs require a Accellor session. Candidate interview APIs use fetch and
// remain public, so this only redirects recruiter traffic to SSO.
axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && typeof window !== 'undefined') {
      const returnPath = `${window.location.pathname}${window.location.search}`;
      window.location.assign(`/login?returnTo=${encodeURIComponent(returnPath)}`);
    }
    return Promise.reject(error);
  }
);

export default axiosClient;
